import React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { get } from 'lodash';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import KnowMoreAboutContract from 'containers/AsiDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts';
import MyContractsTabs from 'components/MyContractsTabs';
import MyContractInfo from 'components/MyContractInfo/ASIContractInfo';
import MyHealthCoverageBloc from './MyHealthCoverage';

const tabItems = (contract: {}) => [
  {
    label: get(contract, ['contractASI', 'fullName'], ''),
    content: (
      <MyContractInfo
        plafond={get(contract, ['contractASI', 'Plafond'], '')}
        franchise={get(contract, ['contractASI', 'Franchise'], '')}
        effectiveDate={get(contract, ['contractASI', 'DebutEffet'], '')}
        dueDate={get(contract, ['contractASI', 'FinEffet'], '')}
      />
    ),
    contractNumber: 'string',
    circulationDate: 'string',
  },
];

const MyContractAndGarantiesTab = (props: {
  intl: IntlShape;
  contractASI: {};
}) => (
  <GaLoadHOC
    category={EVENT_CATEGORIES.ASI_DETAILS}
    label="Mes contrats_Tab 2_Mes contrats"
  >
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Hidden xsDown>
          <KnowMoreAboutContract />
        </Hidden>
        <MyContractsTabs
          tabItems={tabItems(props.contractASI)}
          getDetailContract={() => {}}
          isLoadingDetailContract={false}
          category=""
          label=""
        />
      </Grid>
      <Grid item xs={12}>
        <MyHealthCoverageBloc
          coverages={get(props.contractASI, 'prestations', [])}
          isLoadingDetailContract={false}
        />
      </Grid>
    </Grid>
  </GaLoadHOC>
);

const mapStateToProps = createStructuredSelector<any, {}>({});
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyContractAndGarantiesTab));
